import Vue from 'vue';
import * as Sentry from '@sentry/vue';
import { Replay } from '@sentry/replay';

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    Vue,
    dsn: 'https://3be2812b80c640de9d2ac436c750d825@sg.videsk.io/1386795',
    integrations: [
      new Replay({
        replaysSamplingRate: 0.5,
      }),
    ],
  });
}

export default Sentry;
